import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '@frontend/state';
import BarButton from '@components/bar-button';
import import_stl_svg from '../../../assets/img/SVG_icons/Top/reference_operation/import_stl.svg';
import { img } from '@phi/components';
import { IAuthentication } from '@phi/authentication/frontend';
import { ui_import_ref_stl_model } from '@frontend/input_output';
import ImportSTLTooltip from './ImportSTLTooltip';

export const ImportSTLIcon = import_stl_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        auth: { required: true, type: Object as PropType<IAuthentication> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Import STL Reference';
        },

        disabled() {
            return !this.state.loaded
                || (
                    this.state.framework !== 'onshape'
                    && !this.auth.session_type.value.has('onshape')
                );
        },
    },

    methods: {
        onClick() {
            if (this.state.is_demo)
                return this.auth.show_must_login_modal();
            else if (this.disabled)
                return;
            else
                ui_import_ref_stl_model();
        },
    },

    render() {
        return h(BarButton, {
            id: 'import-stl-button',
            onClick: this.onClick,
            active: false,
            disabled: this.disabled,
            selected: this.state.tut_stage === 13,
            tippy: 'top',
            help: 'import_stl_reference_model',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(import_stl_svg, this.alt),
            tooltip: ImportSTLTooltip,
        });
    },
});
